import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import {
  AlertService,
  TypeOfEnterpriseService,
  AppService,
} from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";

class TypeOfEnterprise {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: "app-type-of-enterprise",
  templateUrl: "./type-of-enterprise.component.html",
})
export class TypeOfEnterpriseComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  typeofenterpriseList: TypeOfEnterprise[] = [];
  isSubmitted = false;
  getTypeofenterprise = {
    id: "",
    name: "",
    description: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;

  constructor(
    public router: Router,
    private dataService: TypeOfEnterpriseService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}

  typeofenterprise = {
    id: "",
    name: "",
    description: "",
    is_active: "Y",
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.allTypeofenterprise();
  }

  allTypeofenterprise() {
    this.loadShow();
    this.dataService
      .getAllTypeofenterprise()
      .pipe()
      .subscribe((data) => {
        this.typeofenterpriseList = data["typeofenterprise"];
        this.rerender();
        this.loadHide();
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  open(content) {
    if (this.getTypeofenterprise.id != null) {
      this.getTypeofenterprise.id = "";
    }
    this.isSubmitted = false;
    (this.typeofenterprise.name = ""),
      (this.typeofenterprise.description = ""),
      (this.typeofenterprise.is_active = "Y");
    this.modalTitle = "Add Type of enterprise";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .getTypeofenterprise(id)
      .pipe()
      .subscribe((data) => {
        this.getTypeofenterprise = data["typeofenterprise"];
        this.typeofenterprise = {
          id: this.getTypeofenterprise.id,
          name: this.getTypeofenterprise.name,
          description: this.getTypeofenterprise.description,
          is_active: this.getTypeofenterprise.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit type of enterprise";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  save(val, f) {
    this.isSubmitted = true;
    if (this.isFieldsInvalid(this.typeofenterprise.name)) {
      return;
    }
    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.typeofenterprise)
          .pipe()
          .subscribe(
            (data) => {
              if (data["status"] == 200) {
                this.loadHide();
                this.modalReference.close();
                this.alertService.success(
                  "Type of enterprise saved successfully",
                  true
                );
                this.allTypeofenterprise();
              } else if (data["status"] == 422) {
                this.alertService.error(data.mesg.name);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
                this.loadHide();
              } else {
                this.alertService.error("errors");
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
                this.loadHide();
              }
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      } else {
        this.dataService
          .typeofenterpriseUpdate(this.typeofenterprise)
          .pipe()
          .subscribe(
            (data) => {
              if (data["status"] == 200) {
                this.loadHide();
                this.modalReference.close();
                this.alertService.success(
                  "Type of enterprise updated successfully",
                  true
                );
                this.allTypeofenterprise();
              } else if (data["status"] == 300) {
                this.loadHide();
                this.alertService.error(data.mesg);
                document
                  .querySelector(".modal")
                  .scrollTo({ top: 0, behavior: "smooth" });
              }
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            }
          );
      }
    }
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .typeofenterpriseDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Sector of enterprise deleted successfully",
              true
            );
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allTypeofenterprise();
          } else {
            this.alertService.error("Sector of enterprise error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
